import React from 'react';
import { useNavigate } from "react-router-dom";
import { Box, Divider, IconButton, Menu, MenuItem, Fade, ListItemText, ListItemIcon } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { FormMode, USysObjects } from '../utils/extensions/constantEx'
import VisibilityIcon from '@mui/icons-material/Visibility';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { HomeContext } from '../utils/contexts/homeContext';

export default function ServiceMenuPopup(props) {
    const { selectedRow } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);

    const { homeState } = React.useContext(HomeContext);

    const open = Boolean(anchorEl);
    const navigate = useNavigate();

    const handleNewPaymentClick = () => {
        handleMoreClose();
        navigate("/service-payment-form", { replace: false });
    }

    const handleViewPaymentsClick = () => {
        handleMoreClose();
        navigate("/service-payments", { replace: false });
    }

    const handleViewClick = () => {
        handleMoreClose();
        navigate("/service-form", {
            replace: false,
            state: {
                formMode: FormMode.ViewMode,
                from: 'search-services',
                serviceId: selectedRow.service_id,
                serviceNurseId: selectedRow.service_nurse_id,
                serviceNurseCount: selectedRow.service_nurse_count ?? 0
            }
        });
    }

    const handleDeleteClick = () => {
        handleMoreClose();
    }

    const handleMoreClick = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleMoreClose = () => {
        setAnchorEl(null);
    };


    return (
        <Box>
            <IconButton onClick={handleMoreClick}>
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="fade-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleMoreClose}
                slotProps={{
                    transition: Fade
                }}
            >

                <MenuItem onClick={handleViewClick} disableRipple>
                    <ListItemIcon>
                        <VisibilityIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>View</ListItemText>
                </MenuItem>
                <Divider sx={{ my: 0.5 }} />

                {
                    homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.Nurses && col.is_delete) &&
                    <MenuItem onClick={handleDeleteClick} disableRipple>
                        <ListItemIcon>
                            <RemoveCircleOutlineIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Delete</ListItemText>
                    </MenuItem>
                }
            </Menu>
        </Box>
    );
} 